import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 0 10px 8px 10px;
  border-radius: 15px 15px 0 0;
  border-top: 1px solid #f5f5f5;
  border-left: 1px solid #f5f5f5;
  border-right: 1px solid #f5f5f5;
  background: #fff;  
`;

export const NavHomeItem = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border:1px solid #dfdfe1;
    padding: 12px;
    flex-direction: column;
    border-radius: 50%;
    margin-top: -15px;
    cursor: pointer;
    position: relative;
`;

export const NavLanguage = styled.div`
    position: absolute;
    top: -5px;
    left: 0;
    width: 24px;
    height: 24px; 
    display: flex;
`;

export const HomeLabel = styled.span`
  font-size: 10px;
    color: #71717A;
`;

export const NavHomeItemCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000000;
  padding: 12px;
  border-radius: 50%;
  margin-top: -32px;
  cursor: pointer;
`;

export const NavItem = styled(NavLink)`
  min-width: 64px;
  width: 100%;
  height: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #71717A;
  font-size: 12px;
    position: relative;

  svg {
    width: 24px;
    height: 24px;
    margin-top: 8px; 
    transition: color 0.3s;
    color: currentColor;
  }

  &.active {
    //border-top: 2px solid #C18244;
    color: #C18244;
      &:after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: 0 auto;
          background-color: #C18244;
          transition: opacity 0.3s;
          width: 40%;
          height: 2px;
      }
    svg {
      color: #C18244;
    }
  }

  &:hover {
    color: #C18244;
  }
  
  @media (max-width: 567px) {
    font-size: 10px;
  }
`;
